import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({ providedIn: 'root' })
export class TemplatesService {
  private url: string = environment.url_onboarding;
  acc: string;

  constructor(private http: HttpClient) {}

  /**
   * Get all Templates
   */
  loadAll(): Observable<any> {
    this.acc = SessionStorage.getItem('currentAccount');
    return this.http.get<any>(`${this.url}/models?account=${this.acc}&skip=0&limit=10&sort=name`).pipe(map(res => res.result));
  }

  /**
   * Get paginated templates
   */
  loadPaginated(): Observable<any> {
    this.acc = SessionStorage.getItem('currentAccount');
    return this.http.get<any>(`${this.url}/v2/models?account=${this.acc}`).pipe(map(res => res.result));
  }

  /**
   * Load more templates
   */
  loadMore(skip: number, limit: number): Observable<any> {
    return this.http.get<any>(`${this.url}/models?skip=${skip}&limit=${limit}&sort=name`).pipe(map(res => res.result));
  }

  /**
   * Search templates
   */
  search(query: string): Observable<any> {
    return this.http.get<any>(`${this.url}/search/models?q=${query}`);
  }
}
